import React from 'react';

interface BillPaymentsDetailsProps {
  payments: any[];
  currencyCode: string;
  /** Deductions applied to the invoice (from the deductions module or transactions) */
  deductions?: any[];
}

/** Expanded row content: every out-transaction that paid a bill, oldest first */
const BillPaymentsDetails: React.FC<BillPaymentsDetailsProps> = ({ payments, currencyCode, deductions }) => {
  const deductionRows = (deductions || []).filter((d: any) => d.status !== 'cancelled');
  if ((!payments || payments.length === 0) && deductionRows.length === 0) {
    return <p className="text-sm text-gray-500 py-2">لا توجد مدفوعات لهذه الفاتورة</p>;
  }
  return (
    <div className="bg-gray-50 rounded-lg p-3 space-y-3">
      {deductionRows.length > 0 && (
        <div>
          <p className="text-sm font-semibold text-gray-700 mb-2">الخصومات ({deductionRows.length})</p>
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-right text-xs text-gray-500">
                <th className="px-3 py-1">المبلغ</th>
                <th className="px-3 py-1">المطبق على الفاتورة</th>
                <th className="px-3 py-1">التاريخ</th>
                <th className="px-3 py-1">السبب</th>
              </tr>
            </thead>
            <tbody>
              {deductionRows.map((d: any, i: number) => {
                const dedCurrency = d.currency?.code || (typeof d.currency === 'string' ? d.currency : '') || currencyCode;
                return (
                  <tr key={d.documentId || d.id || i} className="text-right border-t border-gray-200">
                    <td className="px-3 py-1.5 font-medium text-red-700">- {dedCurrency} {Number(d.amount || 0).toLocaleString()}</td>
                    <td className="px-3 py-1.5 text-red-700">- {currencyCode} {Number(d.invoiceAppliedAmount ?? d.amount ?? 0).toLocaleString()}</td>
                    <td className="px-3 py-1.5 text-gray-600">{d.deductionDate || d.date ? new Date(d.deductionDate || d.date).toLocaleDateString('ar-EG') : '-'}</td>
                    <td className="px-3 py-1.5 text-gray-600">{d.reason || d.description || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {payments && payments.length > 0 && (
        <div>
      <p className="text-sm font-semibold text-gray-700 mb-2">المدفوعات ({payments.length})</p>
      <table className="min-w-full text-sm">
        <thead>
          <tr className="text-right text-xs text-gray-500">
            <th className="px-3 py-1">المبلغ</th>
            <th className="px-3 py-1">المطبق على الفاتورة</th>
            <th className="px-3 py-1">التاريخ</th>
            <th className="px-3 py-1">الوصف</th>
            <th className="px-3 py-1">شيك رقم</th>
            <th className="px-3 py-1">مدفوع من</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p: any) => {
            // Prefer the payment transaction's own currency; a USD invoice can be paid in EGP
            const payCurrency = p.currency?.code || p.currencyCode
              || (typeof p.currency === 'string' ? p.currency : '') || currencyCode;
            // Applied amount in the invoice/bill currency; same-currency payments apply as-is
            const applied = p.invoiceAppliedAmount ?? p.billAppliedAmount ?? p.appliedAmount
              ?? (payCurrency === currencyCode ? p.amount : undefined);
            return (
            <tr key={p.documentId || p.id} className="text-right border-t border-gray-200">
              <td className="px-3 py-1.5 font-medium text-gray-900">{payCurrency} {Number(p.amount || 0).toLocaleString()}</td>
              <td className="px-3 py-1.5 font-medium text-green-700">
                {applied != null ? `${currencyCode} ${Number(applied).toLocaleString()}` : '-'}
              </td>
              <td className="px-3 py-1.5 text-gray-600">{p.date ? new Date(p.date).toLocaleDateString('ar-EG') : '-'}</td>
              <td className="px-3 py-1.5 text-gray-600">{p.description || '-'}</td>
              <td className="px-3 py-1.5 text-gray-600">{p.chequeNumber ? `${p.chequeNumber}${p.chequeDate ? ` (${new Date(p.chequeDate).toLocaleDateString('ar-EG')})` : ''}` : '-'}</td>
              <td className="px-3 py-1.5 text-gray-600">
                {(() => {
                  // bills use paidFrom, invoices use receivedIn
                  const account = p.paidFrom || p.receivedIn;
                  if (account === 'bank') return `بنك: ${p.bankName || '-'}`;
                  if (account === 'safe') return `خزنة: ${p.safeName || '-'}`;
                  return '-';
                })()}
              </td>
            </tr>
            );
          })}
        </tbody>
      </table>
        </div>
      )}
    </div>
  );
};

export default BillPaymentsDetails;
